<template>
  <v-alert
    :value="true"
    color="msr"
    icon="info"
    class="clickable py-2 elevation-24"
    style="top: -9px;"
    @click="reloadPage()"
  >
    <v-layout align-center>
      <div class="subheading mr-3">
        {{ $t('pleaseReloadTheAppThereWasAnUpdate') }}
      </div>
      <v-btn
        class="ml-auto"
        icon
        dark
      >
        <v-icon x-large>
          refresh
        </v-icon>
      </v-btn>
    </v-layout>
  </v-alert>
</template>

<script>
export default {
  methods: {
    reloadPage() {
      window.location.reload();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/UpdateNeededAlert.vue